// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2ExFF","content":"Consent_content__1iRsw","footer":"Consent_footer__kEhBQ"};